import React from 'react';
import { Button, Icon, Tooltip } from '@chakra-ui/react';
import { FiMail } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

export const HelpdeskContactButton = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Tooltip
      label={t('helpdesk.contact', 'Kontakt z helpdeskiem')}
      placement='top'
    >
      <Button
        as='a'
        href='mailto:helpdesk@onehorizon.pl'
        variant='ghost'
        aria-label={t('helpdesk.contact', 'Kontakt z helpdeskiem')}
      >
        <Icon as={FiMail} fontSize='lg' />
      </Button>
    </Tooltip>
  );
};
